var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-flex", { attrs: { "offset-lg1": "" } }, [
        _c("span", [_vm._v("Prev Scene Question:")])
      ]),
      _vm._v(" "),
      _c("span", { staticStyle: { "margin-left": "42px", color: "pink" } }, [
        _vm._v(_vm._s(_vm.prevQuestion))
      ]),
      _vm._v(" "),
      _c("v-flex", { attrs: { "offset-lg1": "" } }, [
        _c("span", [_vm._v("Condition Type")])
      ]),
      _vm._v(" "),
      _c("v-flex", { attrs: { "offset-lg1": "" } }, [
        _c("span", [_vm._v("Set Design (Time):")])
      ]),
      _vm._v(" "),
      _c("span", { staticStyle: { "margin-left": "42px", color: "pink" } }, [
        _vm._v(_vm._s(_vm.setDesign))
      ]),
      _vm._v(" "),
      _c("v-flex", { attrs: { "offset-lg1": "" } }, [
        _c("span", [_vm._v("Character")])
      ]),
      _vm._v(" "),
      _vm._l(_vm.characters, function(character, index) {
        return _c(
          "v-flex",
          { key: index, staticStyle: { "margin-left": "42px" } },
          [
            _c(
              "v-layout",
              { attrs: { row: "" } },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "pink",
                      "margin-top": "5px",
                      "margin-right": "15px"
                    }
                  },
                  [_vm._v(_vm._s(index + 1) + ". " + _vm._s(character.name))]
                ),
                _vm._v(" "),
                _c("v-img", {
                  staticStyle: {
                    "border-radius": "35%",
                    "max-height": "30px",
                    "max-width": "30px"
                  },
                  attrs: { src: character.assetUrl }
                })
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-345aa02a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345aa02a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/conversation/prevCondition.vue
// module id = null
// module chunks = 